var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGpsOffTarget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 44 44",
    style: {
      enableBackground: "new 0 0 44 44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    transform: "translate(-315 -520)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    transform: "translate(315 520)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    fill: "#FFFFFF",
    cx: 22,
    cy: 22,
    r: 22
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#82A996",
    d: "M22.5,38.2c-0.2,0-0.4,0-0.6-0.1c-1.3-0.3-2.2-1.4-2.3-2.7l-0.2-9c0-1.1-0.9-1.9-2-2l-9.1-0.2 c-1.2,0-2.2-0.8-2.6-1.9c-0.4-1.1-0.1-2.2,0.8-2.9c0.2-0.2,0.5-0.3,0.8-0.5l23.3-9.7c1.2-0.5,2.5-0.2,3.4,0.7s1.2,2.2,0.7,3.4 L25,36.6C24.5,37.6,23.6,38.2,22.5,38.2z M31.9,11.1c-0.1,0-0.3,0-0.4,0.1L8.2,20.9C8.1,20.9,8,21,7.9,21c-0.3,0.2-0.2,0.6-0.2,0.7 c0.1,0.3,0.3,0.6,0.8,0.6l9.1,0.2h0c2.2,0,3.9,1.8,3.9,3.9l0.2,9c0,0.6,0.6,0.7,0.7,0.8c0.2,0,0.6,0,0.8-0.4l9.7-23.3 c0.3-0.6-0.1-1-0.2-1.2C32.5,11.3,32.2,11.1,31.9,11.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsOffTarget);
export default __webpack_public_path__ + "static/media/gps-off-target.eb6247d7.svg";
export { ForwardRef as ReactComponent };